<h1> Checkout</h1>
<br />
<div class="toolbarLayout">
  <app-tool-bar [items]="toolbarItems"></app-tool-bar>
</div>
<br />

<form [formGroup]="form" class="form" style="padding-left:15px">
  <div style="width:100%;">
    <div style="width: 550px; float: left; padding-right:40px;">
      <kendo-card class="itemCard">
        <kendo-card-header class="cartHeader">
          Shipping Address
        </kendo-card-header>
        <kendo-card-body>
          <kendo-gridlayout [rows]="[{height:70},{height:70},{height:70},{height:70}]"
                            [cols]="[{width:200},{width:250}]"
                            [gap]="{rows:2, cols:10}">
            <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
              <kendo-formfield>
                <kendo-label> First Name*</kendo-label>
                <kendo-textbox formControlName="firstName"
                               name="firstName"
                               kendoTextBox
                               [clearButton]="true"
                               firstName
                               required></kendo-textbox>
                @if(submitted && f['firstName'].errors) {
                <div>
                  @if(submitted && f['firstName'].errors['required']) {
                  <kendo-formerror>First Name is required</kendo-formerror>
                  }
                </div>
                }
              </kendo-formfield>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
              <kendo-formfield>
                <kendo-label> Last Name*</kendo-label>
                <kendo-textbox formControlName="lastName"
                               [clearButton]="true"
                               lastName
                               required></kendo-textbox>
                @if(submitted && f['lastName'].errors) {
                <div>
                  @if(submitted && f['lastName'].errors['required']) {
                  <kendo-formerror>Last Name is required</kendo-formerror>
                  }
                </div>
                }
              </kendo-formfield>
            </kendo-gridlayout-item>
            <br />
            <kendo-gridlayout-item [row]="2" [col]="1" [colSpan]="1">
              <kendo-formfield>
                <kendo-label> Address*</kendo-label>
                <kendo-textbox formControlName="line1"
                               [clearButton]="true"
                               line1
                               required></kendo-textbox>
                @if(submitted && f['line1'].errors) {
                <div>
                  @if(submitted && f['line1'].errors['required']) {
                  <kendo-formerror>Address is required</kendo-formerror>
                  }
                </div>
                }
              </kendo-formfield>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item [row]="2" [col]="2" [colSpan]="1">
              <kendo-formfield>
                <kendo-label> Apartment, suite, stc. (optional) </kendo-label>
                <kendo-textbox formControlName="line2"
                               [clearButton]="true"
                               line2></kendo-textbox>
              </kendo-formfield>
            </kendo-gridlayout-item>
            <br />
            <kendo-gridlayout-item [row]="3" [col]="1" [colSpan]="1">
              <kendo-formfield>
                <kendo-label> City* </kendo-label>
                <kendo-textbox formControlName="city"
                               [clearButton]="true"
                               city
                               required></kendo-textbox>
                @if(submitted && f['city'].errors) {
                <div>
                  @if(submitted && f['city'].errors['required']) {
                  <kendo-formerror>City is required</kendo-formerror>
                  }
                </div>
                }
              </kendo-formfield>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item [row]="3" [col]="2" [colSpan]="1">
              <kendo-formfield>
                <kendo-label> Postal Code*</kendo-label>
                <kendo-textbox formControlName="postalCode"
                               [clearButton]="true"
                               postalCode
                               required></kendo-textbox>
                @if(submitted && f['postalCode'].errors) {
                <div>
                  @if(submitted && f['postalCode'].errors['required']) {
                  <kendo-formerror>Postal Code is required</kendo-formerror>
                  }
                </div>
                }
              </kendo-formfield>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item [row]="4" [col]="1" [colSpan]="1">
              <kendo-label>Country/Region*</kendo-label>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [row]="4" [col]="2" [colSpan]="1">
              <app-select-field [control]="countryId" (onChange)="onCountrySelectChange($event)"></app-select-field>
              @if(submitted && f['countryId'].errors) {
              <div>
                @if(f['countryId'].errors['required']) {
                <kendo-formerror class="validationMsg"> Country/Region is required</kendo-formerror>
                }
              </div>
              }
            </kendo-gridlayout-item>

            <kendo-gridlayout-item [row]="5" [col]="1" [colSpan]="1">
              <kendo-label>State/Province*</kendo-label>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [row]="5" [col]="2" [colSpan]="1">
              <app-select-field [control]="stateId"></app-select-field>
              @if(submitted && f['stateId'].errors) {
              <div>
                @if(f['stateId'].errors['required']) {
                <kendo-formerror class="validationMsg"> State/Province is required</kendo-formerror>
                }
              </div>
              }
            </kendo-gridlayout-item>
            <br />

            <kendo-gridlayout-item [row]="7" [col]="1" [colSpan]="1">
              <kendo-label>Package Recipient Email*</kendo-label>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [row]="7" [col]="2" [colSpan]="1">
              <kendo-formfield>

                <kendo-textbox formControlName="packageRecipientEmail"
                               [clearButton]="true"
                               packageRecipientEmail
                               required></kendo-textbox>
                @if(submitted && f['packageRecipientEmail'].errors) {
                <div>
                  @if(submitted && f['packageRecipientEmail'].errors['required']) {
                  <kendo-formerror>Package Recipient Email is required</kendo-formerror>
                  }
                </div>
                }
              </kendo-formfield>
            </kendo-gridlayout-item>
            <br />

            <kendo-gridlayout-item [row]="9" [col]="1" [colSpan]="1">
              <kendo-label>Package Recipient Phone*</kendo-label>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [row]="9" [col]="2" [colSpan]="1">
              <kendo-formfield>

                <kendo-textbox formControlName="recipientPhone"
                               [clearButton]="true"
                               recipientPhone
                               required></kendo-textbox>
                @if(submitted && f['recipientPhone'].errors) {
                <div>
                  @if(submitted && f['recipientPhone'].errors['required']) {
                  <kendo-formerror>Package Recipient Phone is required</kendo-formerror>
                  }
                </div>
                }
              </kendo-formfield>
            </kendo-gridlayout-item>
            <br />
            <kendo-gridlayout-item [row]="11" [col]="1" [colSpan]="1">
              <kendo-label>Company</kendo-label>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [row]="11" [col]="2" [colSpan]="1">
              <kendo-formfield>

                <kendo-textbox formControlName="company"
                               [clearButton]="true"
                               company></kendo-textbox>
              </kendo-formfield>
            </kendo-gridlayout-item>
            <br />
          </kendo-gridlayout>
        </kendo-card-body>
        <kendo-card-footer>
        </kendo-card-footer>
      </kendo-card>
      <br />

      @if(shippingMethodRequired){

      <kendo-card class="itemCard">
        <kendo-card-header class="cartHeader">
          Returning Asset Serials
        </kendo-card-header>
        <kendo-card-body>
          <kendo-formfield>
            <kendo-label class="k-display-block"
                         [for]="textbox"
                         text="Returning Asset Serials (Press the + to add to list)"></kendo-label>
            <kendo-textbox #textbox
                           placeholder="Returning Asset Serial"
                           [style.width.px]="200">
              <ng-template kendoTextBoxSuffixTemplate>
                <button kendoButton fillMode="clear" class="btnAddEmail" (click)="addReturningAssetSerial(textbox)"><fa-icon #icon [icon]="addIcon"></fa-icon></button>
              </ng-template>
            </kendo-textbox>
            <br />
            <br />

            <kendo-listbox kendoListBoxDataBinding
                           class="list-box"
                           [data]="serialList"
                           [toolbar]="toolbarSettings">
            </kendo-listbox>


          </kendo-formfield>
        </kendo-card-body>
        <kendo-card-footer>
        </kendo-card-footer>
      </kendo-card>
      <br />
      <kendo-card class="itemCard">
        <kendo-card-header class="cartHeader">
          Shipping Method
        </kendo-card-header>
        <kendo-card-body>
          <kendo-formfield>
            <kendo-label> Shipping Method </kendo-label>
            <app-select-field [control]="shippingMethodId"></app-select-field>
            @if(submitted && f['shippingMethodId'].errors) {
            <div>
              @if(f['shippingMethodId'].errors['required']) {
              <kendo-formerror class="validationMsg"> Shipping Method is required</kendo-formerror>
              }
            </div>
            }
          </kendo-formfield>
          <br/>
          <kendo-formfield>
            <kendo-label> Signature Required?</kendo-label>
            <input kendoCheckBox type="checkbox" name="signatureRequired" formControlName="signatureRequired" [checked]="false" />
          </kendo-formfield>
        </kendo-card-body>
        <kendo-card-footer>
        </kendo-card-footer>
      </kendo-card>
      <br />
      }
      <kendo-card class="itemCard">
        <kendo-card-header class="cartHeader">
          Notes
        </kendo-card-header>
        <kendo-card-body>
          <kendo-formfield>
            <kendo-label> Notes </kendo-label>
            <kendo-textarea formControlName="notes"
                            [rows]="3"
                            [cols]="50"
                            notes></kendo-textarea>
          </kendo-formfield>
        </kendo-card-body>
        <kendo-card-footer>
        </kendo-card-footer>
      </kendo-card>

      <br />
      <kendo-card class="itemCard">
        <kendo-card-header class="cartHeader">
          Additional Emails
        </kendo-card-header>
        <kendo-card-body>
          <kendo-formfield>
            <kendo-label class="k-display-block"
                         [for]="textbox"
                         text="Additional Email (Press the + to add to list)"></kendo-label>
            <kendo-textbox #textbox
                           placeholder="Additional Email"
                           [style.width.px]="200">
              <ng-template kendoTextBoxSuffixTemplate>
                <button kendoButton fillMode="clear" class="btnAddEmail" (click)="addEmail(textbox)"><fa-icon #icon [icon]="addIcon"></fa-icon></button>
              </ng-template>
            </kendo-textbox>
            <br />
            <br />

            <kendo-listbox kendoListBoxDataBinding
                           class="list-box"
                           [data]="additionalEmail"
                           [toolbar]="toolbarSettings">
            </kendo-listbox>


          </kendo-formfield>
        </kendo-card-body>
        <kendo-card-footer>
        </kendo-card-footer>
      </kendo-card>

      <br />
      <!--This will ONLY be if the organization is flagged for lab services-->
      @if(labServiceRequired){
      <kendo-card class="itemCard">
        <kendo-card-header class="cartHeader">
          Lab Services
        </kendo-card-header>
        <kendo-card-body>
          <!--Show a check box that will toggle the lab services-->
          <p>
            <kendo-label class="k-checkbox-label"
                         [for]="showLabServices"
                         text="Does this order require lab services?">

              <input type="checkbox"
                     #showLabServices
                     (change)="openLabServices($event)"
                     kendoCheckBox
                     [checked]="labServicesChecked" />
            </kendo-label>
          </p>

          @if(labServicesChecked){
          <div id="test">
            <p style="font-weight: bold; color: red;">Please note: Except for APs, devices must have an IOS installed by our team prior to shipping. If you select “No”, your device will ship without an IOS or any configuration.</p>
            <kendo-gridlayout [rows]="[{height:50},{height:50},{height:55},{height:55}]"
                              [cols]="[{width:200},{width:250}]"
                              [gap]="{rows:2, cols:10}">
              <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">

                <kendo-gridlayout-item [row]="4" [col]="1" [colSpan]="1">
                  <kendo-label>Engineer Email*</kendo-label>
                </kendo-gridlayout-item>
                <kendo-gridlayout-item [row]="4" [col]="2" [colSpan]="1">
                  <app-select-field [control]="clientEngineerId"></app-select-field>
                  @if(submitted && labServiceRequired && labServicesChecked && f['clientEngineerId'].errors) {
                  <div>
                    @if(submitted && labServiceRequired && labServicesChecked && f['clientEngineerId'].errors['required']){
                    <kendo-formerror class="validationMsg"> Engineer Email is required</kendo-formerror>
                    }
                  </div>
                  }
                </kendo-gridlayout-item>



              </kendo-gridlayout-item>
              <br />
              <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
                <kendo-formfield>
                  <kendo-label> Project Manager Email* </kendo-label>
                  <kendo-textbox formControlName="projectManagerEmail"
                                 [clearButton]="true"
                                 projectManagerEmail>
                  </kendo-textbox>
                  @if(submitted && labServiceRequired && labServicesChecked && f['projectManagerEmail'].errors){
                  <div>
                    @if(submitted && labServiceRequired && labServicesChecked && f['projectManagerEmail'].errors['required']){
                    <kendo-formerror>Project Manager Email is required</kendo-formerror>
                    }
                  </div>
                  }
                </kendo-formfield>
              </kendo-gridlayout-item>
              <br />
              <kendo-gridlayout-item [row]="2" [col]="1" [colSpan]="1">
                <kendo-formfield>
                  <div style="padding-top:20px">
                    <kendo-label> Shipping Instructions </kendo-label>
                    <kendo-textbox formControlName="shippingInstructions"
                                   [clearButton]="true"
                                   shippingInstructions
                                   style="width: 200px;">
                    </kendo-textbox>
                  </div>
                  @if(submitted && labServiceRequired && labServicesChecked && f['shippingInstructions'].errors){
                  <div>
                    @if(submitted && labServiceRequired && labServicesChecked && f['shippingInstructions'].errors['required']){
                    <kendo-formerror>Shipping Instructions is required</kendo-formerror>
                    }
                  </div>
                  }
                </kendo-formfield>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item [row]="2" [col]="2" [colSpan]="1">
                <kendo-formfield>
                  <div style="padding-top:20px">
                    <kendo-label> Additional Email </kendo-label>
                    <kendo-textbox formControlName="benchTemplateEmails"
                                   [clearButton]="true"
                                   benchTemplateEmails
                                   style="width: 250px;">
                    </kendo-textbox>
                  </div>
                </kendo-formfield>
              </kendo-gridlayout-item>
              <br />
              <kendo-gridlayout-item [row]="3" [col]="1" [colSpan]="1">
                <kendo-formfield>
                  <div style="padding-top:40px">
                    <kendo-label> On-site Date* </kendo-label>
                    <kendo-datepicker formControlName="siteDate"
                                      placeholder=""
                                      name="siteDate"
                                      [style.width.px]="170">
                    </kendo-datepicker>
                  </div>
                  @if(submitted && labServiceRequired && f['siteDate'].errors){
                  <div>
                    @if(submitted && labServiceRequired && labServicesChecked && f['siteDate'].errors['required']){
                    <kendo-formerror>Arrvial Date is required</kendo-formerror>
                    }
                  </div>
                  }
                </kendo-formfield>
              </kendo-gridlayout-item>

              <kendo-gridlayout-item [row]="3" [col]="2" [colSpan]="1">
                <kendo-formfield>
                  <div style="padding-top:40px">
                    <kendo-label> Customer Reference Number* </kendo-label>
                    <kendo-textbox formControlName="customerReferenceNumber"
                                   [clearButton]="true"
                                   customerReferenceNumber
                                   style="width: 250px;">
                    </kendo-textbox>
                  </div>
                  @if(submitted && labServiceRequired && labServicesChecked && f['customerReferenceNumber'].errors) {
                  <div>
                    @if(submitted && labServiceRequired && labServicesChecked && f['customerReferenceNumber'].errors['required']) {
                    <kendo-formerror>Customer Reference Number is required</kendo-formerror>
                    }
                  </div>
                  }
                </kendo-formfield>
              </kendo-gridlayout-item>
              <br />
            </kendo-gridlayout>
          </div>
          }
        </kendo-card-body>
        <kendo-card-footer>
        </kendo-card-footer>
      </kendo-card>
      }
    </div>
    <br />

    <div style="width:50%; float: left; ">
      <kendo-stacklayout orientation="vertical" [align]="{ vertical: 'top' }">
        <kendo-stacklayout orientation="horizontal" [style.height.px]="300">
          <div class="box content">
            <kendo-card class="cartCard">
              <kendo-card-header class="cartHeader">
                CART
              </kendo-card-header>
              <kendo-card-body>
                <div style="padding: 0px 10px;">
                  <div class="cartContainer">
                    @for(item of cartItems; track item) {
                    <table id="cartTable" style="padding-bottom: 15px;">
                      <thead>
                        <tr>
                          <th style="text-align: left; width: 400px">Product</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody style="border-top-color: green;">
                        <tr>
                          <td style="text-align: left; width: 400px">
                            {{item.itemTitle}}
                            @if(item.option != ""){
                              <br>
                              <ul>
                                <li>{{item.option}}</li>
                              </ul>
                            }
                          </td>
                          <td> {{item.quantity}}</td>
                        </tr>
                      </tbody>
                    </table>
                    }
                    @for(item of cartMiscItems; track item) {
                    <table id="cartTable">
                      <thead>
                        <tr>
                          <th style="text-align: left; width: 400px">Product</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody style="border-top-color: green;">
                        <tr>
                          <td style="text-align: left; width: 400px">{{item.miscellaneousItemTitle}} - {{item.isLegalHold}}</td>
                          <td> {{item.quantity}}</td>
                        </tr>
                      </tbody>
                    </table>
                    }
                  </div>
                </div>
              </kendo-card-body>
              <kendo-card-footer>
              </kendo-card-footer>
            </kendo-card>
          </div>
        </kendo-stacklayout>
      </kendo-stacklayout>
    </div>
  </div>
</form>

<kendo-stacklayout orientation="vertical" style="width:100%">

  @if (openTimeout) {
  <kendo-dialog title="Attention!" [animation]="true" (close)="closeTimeoutDialog()">
    <p>
      Certain items you've reserved went past the 30 minute time cap: <br>
    </p>

    @for(item of timedOutCartItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.itemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    @for(item of timedOutCartMiscItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.miscellaneousItemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    <p>
      The other items in your cart have been removed and returned to available status. <br>
      Please re-add your items and checkout within the 30 minute mark.
    </p>

    <kendo-dialog-actions>
      @if (dialogIcon) {
      <button kendoButton class="ackBtn" themeColor="tertiary" (click)="acknowledgeTimedOutItems()" [svgIcon]="dialogYes">
        Acknowledge
      </button>
      }
      @else {
      <button kendoButton class="ackBtn" themeColor="tertiary" (click)="acknowledgeTimedOutItems()">
        Acknowledge
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>
